export const TipoFechaGlosa = [
    {
        nombreEnvio: "fechaAlta",
        nombreProceso: "FECHA DE ALTA"
    }, {
        nombreEnvio: "fechaBaja",
        nombreProceso: "FECHA DE BAJA"
    }, {
        nombreEnvio: "fechaIngreso",
        nombreProceso: "FECHA DE INGRESO"
    }];

export const nombreEnvio = (nombreProceso: string) => {
    return TipoFechaGlosa.find(tipo => tipo.nombreProceso === nombreProceso);
};


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/config_glosas/modelo/TipoFechaGlosa.ts